
export const initialKpiCustomer = () => ({
    loading: false,
    selectedDate: new Date(),
    listAllSalesCustomer: [],
})

export const updateKpiCustomer = (currentState, action) => {
    const { kpiCustomer, selectedDate } = action

    return {
        ...currentState,
        selectedDate: selectedDate ? new Date(selectedDate) : currentState.selectedDate,
        kpiCustomer: {
            ...currentState.kpiCustomer,
            ...kpiCustomer,
        },
    }
}